import { apiClient } from './api';
import type {
  OutstandingResponse,
  PaymentInitiateRequest,
  PaymentInitiateResponse,
  PaymentSuccessRequest,
  PaymentSuccessResponse,
  PaymentFailureRequest,
  PaymentFailureResponse,
  PaymentStatusResponse,
  PaymentHistoryResponse,
  BalanceResponse,
  EffectiveBalanceResponse
} from '../types';

export class TallyService {
  
  /**
   * Get outstanding charges for a flat
   */
  async getOutstandingCharges(flatId: string): Promise<OutstandingResponse> {
    return apiClient.get<OutstandingResponse>(`/payment/outstanding/${flatId}`);
  }

  /**
   * Initiate a payment (full or partial)
   */
  async initiatePayment(request: PaymentInitiateRequest): Promise<PaymentInitiateResponse> {
    return apiClient.post<PaymentInitiateResponse>('/payment/initiate', request);
  }

  /**
   * Handle successful payment
   */
  async handlePaymentSuccess(request: PaymentSuccessRequest): Promise<PaymentSuccessResponse> {
    console.log('✅ TallyService: Calling payment success API with:', request);
    try {
      const response = await apiClient.post<PaymentSuccessResponse>('/payment/success', request);
      console.log('✅ TallyService: Payment success API response:', response);
      return response;
    } catch (error) {
      console.error('❌ TallyService: Payment success API failed:', error);
      throw error;
    }
  }

  /**
   * Handle failed payment
   */
  async handlePaymentFailure(request: PaymentFailureRequest): Promise<PaymentFailureResponse> {
    console.log('🔥 TallyService: Calling payment failure API with:', request);
    const response = await apiClient.post<PaymentFailureResponse>('/payment/failure', request);
    console.log('🔥 TallyService: Payment failure API response:', response);
    return response;
  }

  /**
   * Get payment status by request ID
   */
  async getPaymentStatus(paymentRequestId: string): Promise<PaymentStatusResponse> {
    return apiClient.get<PaymentStatusResponse>(`/payment/status/${paymentRequestId}`);
  }

  /**
   * Get payment history for a flat
   */
  async getPaymentHistory(flatId: string, limit: number = 10): Promise<PaymentHistoryResponse> {
    return apiClient.get<PaymentHistoryResponse>(`/payment/history/${flatId}?limit=${limit}`);
  }

  /**
   * Get updated balance after payment
   */
  async getBalance(flatId: string): Promise<BalanceResponse> {
    return apiClient.get<BalanceResponse>(`/tally-sync/balance/${flatId}`);
  }

  /**
   * Get effective balance (recommended endpoint)
   */
  async getEffectiveBalance(flatId: string): Promise<EffectiveBalanceResponse> {
    return apiClient.get<EffectiveBalanceResponse>(`/tally-sync/effective-balance/${flatId}`);
  }

  /**
   * Health check method
   */
  async healthCheck(): Promise<{ status: string; timestamp: string }> {
    return apiClient.get('/health');
  }
}

// Create singleton instance
export const tallyService = new TallyService();